import React, { useEffect, useState, useRef } from "react";
import heart from "../../images/user-orange.svg";
import { Controller, useForm } from "react-hook-form";
import { USER_ROLES } from "../../App.config";
import * as utilities from "../../utilities/utils";
import backArrow from "../../images/back-arrow.svg";
import history from "../../utilities/history";
import { trim } from "lodash";
import DropdownComponent from "../../containers/Dropdown";
import CustomDatePicker from "../../containers/Common/CustomDatePicker";
import moment from "moment"
import "react-datepicker/dist/react-datepicker.css";
import DisplayEmployeeName from "../../containers/DisplayEmployeeName";
import swal from 'sweetalert';


const BackupUserForm = (props) => {

    const { control, register, handleSubmit, watch, formState: { errors }, reset, setValue, getValues } = useForm();
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedBackupUser, setSelectedBackupUser] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);



    useEffect(() => {
        if (props.userAuthReducer.isUserSet) {
            props.getBackupUsers(props.userAuthReducer.authUser.regionId);
            setSelectedBackupUser(props.userAuthReducer.authUser.backupUserId);
            props.resetIsUserSet();
        }
    }, [props.userAuthReducer.isUserSet]);

    useEffect(() => {
        reset();
        props.getAllCompanyList();
        props.resetSelectedCompany(null);
    }, []);

    useEffect(() => {
        return function cleanup() {
            props.resetSelectedCompany(null);
            props.resetAuthUser();
            setSelectedCompany(null);
            setSelectedUser(null);
            setSelectedBackupUser(null);
        };
    }, []);

    useEffect(() => {
        if (props.profileReducer.managersDetails && props.profileReducer.managersDetails.roleId == USER_ROLES.FULL_HR) {
            props.getAllAuthUsers(props.profileReducer.managersDetails.companyId);
            setSelectedCompany(props.profileReducer.managersDetails.companyId);
        }
        else if (props.profileReducer.managersDetails && props.profileReducer.managersDetails.roleId == USER_ROLES.LIMITED_CAL_MGR) {
            props.getAuthUserById(props.profileReducer.managersDetails.managerId);
            setSelectedCompany(props.profileReducer.managersDetails.companyId);
            setSelectedUser(props.profileReducer.managersDetails.managerId)
        }
    }, [props.profileReducer.managersDetails.roleId]);

    const onChange = (event) => {

        if (event.target.name == "users") {
            setStartDate(null);
            setEndDate(null);
            setSelectedUser(event.target.value);
            if (event.target.value)
                props.getAuthUserById(event.target.value);
            else
                props.resetAuthUser();
        }
        else if (event.target.name == "backupUserId") {
            setSelectedBackupUser(event.target.value);
        }
    }

    useEffect(() => {
        if (props.userAuthReducer && props.userAuthReducer.authUser) {
            setValue('backupUserId', props.userAuthReducer.authUser.backupUserId, { shouldValidate: true });
            setValue('startDate', moment(props.userAuthReducer.authUser.startDate).toDate(), { shouldValidate: true });
            setValue('endDate', moment(props.userAuthReducer.authUser.endDate).toDate(), { shouldValidate: true });
            props.userAuthReducer.authUser.startDate && setStartDate(moment(props.userAuthReducer.authUser.startDate).toDate());
            props.userAuthReducer.authUser.endDate && setEndDate(moment(props.userAuthReducer.authUser.endDate).toDate());
        }
    }, [props.userAuthReducer && props.userAuthReducer.authUser])

    const onDropDownChange = (event) => {
        setSelectedCompany(utilities.extractFirstValueOfArray(event.value));
        if (utilities.extractFirstValueOfArray(event.value))
            props.getAllAuthUsers(utilities.extractFirstValueOfArray(event.value));
        else {
            setSelectedCompany(null);
            props.resetAllAuthUsersAndBackupUser();
        }
    }

    const onBackupDelete = (data) => {
        return (swal({
            title: "Are you sure you want to delete backup user?",
            // text: "Once deleted, you will not be able to recover this imaginary file!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    deleteBackupUser(data);
                } else {
                    swal("Backup user not deleted");
                }
            }))
    }

    const deleteBackupUser = (data) => {
        let payload = "";
        if (props.profileReducer.managersDetails && props.profileReducer.managersDetails.roleId == USER_ROLES.LIMITED_CAL_MGR) {
            payload = {
                "userId": props.userAuthReducer.authUser.authUserId,
                "backupUserId": data.backupUserId,
                // "startDate": moment(startDate).format("YYYY MM DD"),
                // "endDate": moment(endDate).format("YYYY MM DD"),
                "isDelete": true
            }
        }
        else {
            payload = {
                "userId": data.users,
                "backupUserId": data.backupUserId,
                // "startDate": moment(startDate).format("YYYY MM DD"),
                // "endDate": moment(endDate).format("YYYY MM DD"),
                "isDelete": true
            }
        }
        if (data && data.backupUserId) {
            props.handleSubmit(payload);
            history.push("/dashboard");
        }

    }

    const saveBackupUser = (data) => {
        let payload = "";
        if (props.profileReducer.managersDetails && props.profileReducer.managersDetails.roleId == USER_ROLES.LIMITED_CAL_MGR) {
            payload = {
                "userId": props.userAuthReducer.authUser.authUserId,
                "backupUserId": data.backupUserId,
                "startDate": moment(startDate).format("YYYY MM DD"),
                "endDate": moment(endDate).format("YYYY MM DD"),
                "isDelete": false
            }
        }
        else {
            payload = {
                "userId": data.users,
                "backupUserId": data.backupUserId,
                "startDate": moment(startDate).format("YYYY MM DD"),
                "endDate": moment(endDate).format("YYYY MM DD"),
                "isDelete": false
            }
        }
        if (data && data.backupUserId) {
            props.handleSubmit(payload);
            history.push("/dashboard");
        }

    }

    return (
        <>
            <div className="Dashboard-Content">
                <form onSubmit={handleSubmit(saveBackupUser)}>
                    <div className="Inner-cell">
                        <DisplayEmployeeName context={props.context} />
                        <div className="Panel-cell">
                            <div className="Panel-header">
                                <img
                                    tabIndex="-1"
                                    className="btn btn-back"
                                    onClick={() => history.push("/dashboard")}
                                    src={backArrow}
                                    alt="back-arrow"
                                />
                                <div className="p-img">
                                    <img src={heart} alt="" />
                                </div>
                                <h2>
                                    <span>
                                        {/* Back-up User */}
                                        {props.context.t("STD-Dashboard.label.Sidebar.Back.up.User.title-14")}
                                    </span>
                                </h2>
                            </div>
                            <div className="Panel-search">

                                {props.roleId == USER_ROLES.ADMIN && <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <div className="example">
                                            <label>Select Company
                                                <span size="5" className="error-star">
                                                    *
                                                </span>
                                            </label>
                                            <DropdownComponent
                                                name="companyList"
                                                options={props.userAuthReducer.companyList}
                                                isMultiSelect={false}
                                                option_key="companyId"
                                                option_display="companyName"
                                                onChange={onDropDownChange}
                                                values={[selectedCompany]}
                                                simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                                                selectAllText="Select All Options"
                                                isSearchOption={true}
                                                searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                                            // ref={state.location.ref}
                                            />
                                            <small className="text-danger">{errors.userRoleId?.type === 'required' && "User role id required"}</small>

                                        </div>
                                    </div>
                                </div>}

                                {(props.roleId == USER_ROLES.ADMIN || props.roleId == USER_ROLES.FULL_HR) && <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <div className="example">
                                            <label>{props.context.t("STD-Dashboard.label.heading.title-7")}
                                                <span size="5" className="error-star">
                                                    *
                                                </span>
                                            </label>
                                            <select className="form-control form-control-lg"
                                                {...register("users", {
                                                    required: true,
                                                    onChange: onChange
                                                })}
                                            >
                                                <option value="">-:{props.context.t("BACKUP-USER-SECTION.Select.Option")}:-</option>
                                                {props.userAuthReducer && props.userAuthReducer.allAuthUsers.map((user) => {
                                                    if (user.userRoleId == USER_ROLES.LIMITED_CAL_MGR && !user.isTerminated) {
                                                        return (
                                                            <option
                                                                // selected={props.formData && (props.formData.userRoleId == roles.authUserRoleId) && "selected"}
                                                                value={user.authUserId}>
                                                                {user.firstName + " " + user.lastName + "(" + user.email + ")"}
                                                            </option>
                                                        )
                                                    }
                                                })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <div className="example">
                                            <label>{props.context.t("BACKUP-USER-SECTION.Start.Date")}
                                                <span size="5" className="error-star">
                                                    *
                                                </span>
                                            </label>
                                            <CustomDatePicker
                                                {...register("startDate", {
                                                    required: true,
                                                    // onChange: onChange
                                                })}
                                                id="startDate"
                                                selected={startDate}
                                                onChange={(date) => {
                                                    setStartDate(date);
                                                    setValue("startDate", date);
                                                    // onDateChange(e, "dateOfHire");
                                                }}
                                                minDate={moment().toDate()}
                                                placeholderText={props.context.t("BACKUP-USER-SECTION.Start.Date")}
                                                // ref={state.dateOfHire.ref}
                                                className="form-control"
                                            />
                                            {/* {state.startDate?.error && (
                                                <span className="error">{state.startDate.error}</span>
                                            )} */}
                                        </div>
                                    </div>
                                </div>
                                {startDate &&
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <div className="example">
                                                <label>{props.context.t("BACKUP-USER-SECTION.End.Date")}
                                                    <span size="5" className="error-star">
                                                        *
                                                    </span>
                                                </label>
                                                <CustomDatePicker
                                                    {...register("endDate", {
                                                        required: true
                                                        // onChange: onChange
                                                    })}
                                                    id="endDate"
                                                    selected={endDate}
                                                    onChange={(date) => {
                                                        setEndDate(date);
                                                        setValue("endDate", date);
                                                        // onDateChange(e, "dateOfHire");
                                                    }}
                                                    // minDate={0}
                                                    placeholderText={props.context.t("BACKUP-USER-SECTION.End.Date")}
                                                    // ref={state.dateOfHire.ref}
                                                    className="form-control"
                                                    minDate={startDate}
                                                />
                                                {/* {state.startDate?.error && (
                                                <span className="error">{state.startDate.error}</span>
                                            )} */}
                                            </div>
                                        </div>
                                    </div>}
                                <div className="form-row">

                                    <div className="form-group col-md-6">
                                        <div className="example">
                                            <label>{props.context.t("BACKUP-USER-SECTION.Select.Back-up.User")}
                                                <span size="5" className="error-star">
                                                    *
                                                </span>
                                            </label>
                                            <select className="form-control form-control-lg"
                                                {...register("backupUserId",
                                                    {
                                                        required: true,
                                                        value: props.userAuthReducer && props.userAuthReducer.authUser ? props.userAuthReducer.authUser.backupUserId : null,
                                                        onChange: onChange
                                                    }
                                                )}
                                            >
                                                <option value="">-:{props.context.t("BACKUP-USER-SECTION.Select.Option")}:-</option>
                                                {props.userAuthReducer && props.userAuthReducer.backupUserList.map((backupUser) => {
                                                    if (props.userAuthReducer.authUser.authUserId != backupUser.authUserId) {
                                                        if (backupUser.userRoleId == USER_ROLES.LIMITED_CAL_MGR) {
                                                            return (
                                                                <option
                                                                    selected={props.userAuthReducer.authUser.backupUserId == backupUser.authUserId && "selected"}
                                                                    value={backupUser.authUserId}>
                                                                    {backupUser.firstName + " " + backupUser.lastName + "(" + backupUser.email + ")"}
                                                                </option>
                                                            )
                                                        }
                                                    }
                                                })
                                                }
                                            </select>
                                            <small className="text-danger">{errors.backupUserId?.type === 'required' && "Please select back-up user"}</small>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row">
                                    {selectedCompany && selectedUser && selectedBackupUser && startDate && endDate && <div>
                                        <button type="submit" className="btn btn-primary float-right">
                                            Submit
                                    </button>
                                    </div>}
                                    {selectedCompany && selectedUser && selectedBackupUser && startDate && endDate && props.userAuthReducer && props.userAuthReducer.authUser && props.userAuthReducer.authUser.backupUserId && <div className="ml-2">
                                        <button type="submit" className="btn btn-danger float-right" onClick={handleSubmit(onBackupDelete)}>
                                        Cancel
                                    </button>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};
export default BackupUserForm;
